import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Logger, LoggingService, LoginService } from 'vas-mobile-api';

@Injectable()
export class AuthguardService implements CanActivate {

  private loggedOn = false;
  private logger: Logger;

  constructor(
    private router: Router,
    private loggingVasService: LoggingService,
    private loginService: LoginService
  ) {
    this.logger = loggingVasService.getLogger(AuthguardService.name);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    // if (this.isLoggedOn()) {
    if (this.loginService.isLoggedIn) {
      return true;
    } else {
      // not logged in so redirect to login page with the return url
      this.logger.error('Acitavete the route, return false');
      this.router.navigate(['login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }

}
